import React, { FC } from 'react';
import { Hyperlink } from '../../../components/Hyperlink';

type Props = {
  href: string;
  onClick?: () => void;
  target?: string | undefined;
  rel?: string | undefined;
  source?: string;
};

export const FooterItem: FC<Props> = ({
  children,
  href,
  onClick,
  target,
  rel,
  source,
}) => (
  <li>
    <Hyperlink
      className="footer__group__list__item"
      href={href}
      onClick={onClick}
      target={target}
      rel={rel}
      source={source}
    >
      {children}
    </Hyperlink>
  </li>
);

FooterItem.defaultProps = {
  onClick: /* istanbul ignore next */ () => {},
  target: undefined,
  rel: undefined,
  source: '',
};
